import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getUserToken } from '../common/resubale-functions';
import LoginForm from '../components/login/login';
import LoginOtp from '../components/login/login_otp';

const Login = () => {
  const history = useHistory();
  const search = useLocation().search;
  const redirectTo = new URLSearchParams(search).get('redirectTo');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [number, setNumber] = useState('');
  const [isContinue, setIscontinue] = useState(false);
  const [loginToken, setLOginToken] = useState('');
  const [selectedCountry, setSelectCountry] = useState({
    code: 'GB',
    dial_code: '+44',
    flag: '🇬🇧',
    name: 'United Kingdom',
    preferred: true,
  });
  
  useEffect(() => {
    checkLogin();
  },[]);
  
  const checkLogin = ()=>{
    if (getUserToken()) {
      // Redirect to the specified URL if redirectTo param exists, otherwise go to credits
      if (redirectTo) {
        history.replace(redirectTo);
      } else {
        history.replace('/credits');
      }
    }
  }

  const handleInputChange = (val) => {
    setNumber(val);
  };

  const handleChangeClick = () => {
    setPhoneNumber(null);
  };
  return (
    <>
      <div className=''>
        {((phoneNumber == null || phoneNumber == '') && isContinue == false) ||
        phoneNumber == null ||
        phoneNumber == '' ||
        isContinue == false ? (
          <LoginForm
            handleChange={handleInputChange}
            setIscontinue={setIscontinue}
            isContinue={isContinue}
            inputNumber={number}
            setPhoneNumber={setPhoneNumber}
            phoneNumber={phoneNumber}
            selectedCountry={selectedCountry}
            setSelectCountry={setSelectCountry}
          />
        ) : (
          <LoginOtp
            phoneNumber={phoneNumber}
            handleChangeNumber={handleChangeClick}
            setIscontinue={setIscontinue}
            isContinue={isContinue}
            selectedCountry={selectedCountry}
            setLOginToken={setLOginToken}
            loginToken={loginToken}
          />
        )}
      </div>
    </>
  );
};

export default Login;
